<template>
<div class="chapter">
<div class="inner_page">
<h1 class="cn"><a href="#/MontanaLegacy_toc#chap-2">C<span class="small">HAPTER</span> T<span class="small">WO</span></a></h1>
<p class="img"><img alt="art" src="images/Art_PLine.jpg"/></p>
<p class="cotx"><span class="dropcap">C</span>ome on, Jess.” Cal slid behind the wheel of the battered old pickup and waited while Jesse stored a shovel in the back before
         climbing into the passenger side. “Your aunt’ll have my hide if I don’t get you up to the house in time for the service.”
      </p>
<p>“Doesn’t matter.” Jesse wiped his muddy hands on his jeans. “Coot won’t like it.”</p>
<p>“Now what makes you say that?”</p>
<p>The younger man glanced over. “He never liked fuss, Cal. Neither do I.”</p>
<p>“This isn’t fuss. It’s the only way we have of paying our respects. Coot knew that. It’s why he told his sister just what
         to do in the event of his death.” Cal’s voice lowered. “This is important to Cora. She’s hurting as much as you, Jess.”
      </p>
<p>“I know. I wish I could ease her pain.” Jesse turned to stare out the side window as the truck rumbled along the rough road.
         Next to Coot, Cal Randall was the closest thing Jesse McCord had to a father, since his own had died twenty years ago, leaving
         him lost and bewildered at the tender age of twelve.
      </p>
<p>Cal wasn’t one to give advice, but when he did, Jesse heeded it, however reluctantly. “I suppose I’ll have to wear a suit.”</p>
<p>Cal nodded. “Me, too. Though I’ve no use for them.”</p>
<p>Jesse looked over. “Didn’t know you owned one.”</p>
<p>Cal grinned. “Haven’t had much need for it, but now and again it comes in handy.”</p>
<p>“Especially if you’re trying to impress a lady.”</p>
<p>“I’ll leave that to you, Jess.”</p>
<p>The two shared a smile.</p>
<p>As they rolled to a stop by the back door, Jesse caught sight of the unfamiliar vehicles. “Well, well. Looks like the gang’s
         all here.” He stepped down from the pickup and turned from the Harley to the sports car. “Let’s see. Which one do you think
         belongs to our free spirit, and which to Hollywood’s golden boy?”
      </p>
<p>Cal shook his head. “Let it be, Jess. They’re family.”</p>
<p>“Yeah. I keep forgetting.” His tone roughened. “Of course, it’s hard to remember when you don’t see someone for ten or fifteen
         years.”
      </p>
<p>“They’re here now. Here for their grandfather. That’s all that matters.”</p>
<p>Jesse nodded. “And by this time tomorrow, they’ll be gone.”</p>
<p>He stormed up the steps, hoping to escape to his room. Instead, after scraping mud from his boots and washing his hands at
         the big sink in the mudroom, he stepped into the kitchen and came face-to-face with a roomful. His great-aunt looked up from
         the table where his grandfather’s lawyer was seated beside the minister. On the other side sat his two cousins.
      </p>
<p>“Well.” If he couldn’t manage a smile, at least he didn’t groan. “Wyatt. Zane. It’s been too long.”</p>
<p>“Yeah.” Wyatt stepped forward to offer his hand. “The place looks the same as I remember.”</p>
<p>“Yeah. Some things never change.” But Wyatt had. Even the proper suit and tie couldn’t erase the long hair and casual air
         that gave him the look of an eternal surfer. Maybe, Jesse thought, that’s what Wyatt was. Always dashing off to find the next
         big wave to ride.
      </p>
<p>When he turned to Zane, Jesse was startled by how much his younger cousin had changed. He’d expected a smoothness to Zane,
         a polish that could only come from easy living. After all, the suit was custom-made. The shoes Italian. And the watch on his
         wrist cost more than Jesse’s last truck. But there was a toughness in his younger cousin’s eyes, a strength in his demeanor
         that didn’t quite fit the image he’d formed in his mind.
      </p>
<p>“How’s Hollywood? I hear you’re working with some hotshot director now.”</p>
<p>“Steve Michaelson.” Zane stuck out his hand. “I assisted on his latest documentary. It’ll be on PBS next fall. Good to see
         you, Jess. I wish it could have been under happier circumstances.”
      </p>
<p>“Yeah, well, too bad you had to wait until Coot was dead to pay a call.”</p>
<p>“Jesse.” To avoid an all-out war, Cora stepped between them. “I was just about to introduce Vernon to your cousins.” She looped
         an arm through each of theirs. “Boys, this is Vernon McVicker, Coot’s lawyer. Vernon, these are my great-nephews, Zane and
         Wyatt McCord.”
      </p>
<p>The man who pushed away from the table had sad, tired eyes in a long and lean face. Sparse gray hair was combed straight back,
         adding to his hound-dog expression. As he approached he studied them as he might specimens, with more than casual interest.
         “You’d be Wade’s son,” he said to Zane. He turned to Wyatt. “And you’d be Ben’s.”
      </p>
<p>They both nodded.</p>
<p>Relieved that she’d managed to smother Jesse’s temper for the moment, Cora managed a smile. “Jess, why don’t you go ahead
         upstairs and get dressed while we wait. Reverend Carson is here to begin the service, as soon as we’re ready.”
      </p>
<p>Jesse was grateful for the chance to escape. The last thing he wanted to do was stand around making small talk. “I’ll just
         be a few minutes.”
      </p>
<p>As he stalked up the stairs he thought about the two cousins who were no more than strangers now. There’d been a time when
         the three of them had been inseparable. They’d grown up wild and free on their grandfather’s ranch, swimming in the creek,
         riding bareback across the hills, daring one another to try every dangerous, reckless stunt a young boy’s mind could imagine.
      </p>
<p>They’d all lived here in various wings of the house. One big, noisy family. Even after the death of his father, Jesse had
         felt safe and protected, because he’d been surrounded by so many family members. But gradually the cracks in the family had
         begun to show signs of stress. Ben had left first, taking Wyatt away. Later it was Wade, heading off to California with his
         wife and son.
      </p>
<p>Jesse undressed and stepped into the shower, letting the hot water beat on the knot of tension at the back of his neck. After
         toweling himself dry he slipped into a crisp white shirt, tucking it into the waistband of dark pants.
      </p>
<p>As he ran his fingers through his wet hair he paused. He didn’t blame his cousins for leaving. They’d been only kids when
         their fathers had had enough of old Coot’s ravings and had pulled up stakes, in search of a better life. But they’d had plenty
         of years to come back after they were old enough to be on their own, if that’s what they’d wanted. The fact that they’d never
         returned to the ranch meant one thing to Jesse. They hadn’t loved their grandfather enough to spend even a week with him.
         Not a single week in all these long years.
      </p>
<p>Jesse slid his arms into the suit jacket, hating the way it felt. Stiff. Phony. That’s what this whole fiasco was. A service.
         For what? So the minister could say a few fancy words about a man who’d never set foot in his church? Coot was gone. Nothing
         would bring him back.
      </p>
<p>He took a last glimpse in the mirror, straightening his tie, then slammed out of the room and down the stairs. What he really
         wanted to do was to get into his truck and drive up to the hills where he and Coot used to spend so much time together. That
         would mean more to him than any stuffy service. At least then he’d be able to properly grieve.
      </p>
<p>And he would, he vowed. As soon as the others left, and he had time to himself, he’d bury his grandfather in his own way.</p>
<p class="spb">They stood together on a windswept hill. The rain had stopped, leaving the surrounding countryside looking fresh and green,
         frosted with the pale pink blossoms of bitterroot and waving tassels of golden bear grass.
      </p>
<p>Jesse looked around at those assembled. It was the first time he’d ever seen so many ranch hands together at one time. Even
         their roundup barbecue, traditionally held after the cattle had been brought down from the high pastures in late summer, never
         included all the wranglers, since some were needed to tend the herds. But today, out of respect for the man who had built
         this amazing spread and had been its heart and soul, every last man was here. Dandy Davis, wearing a spiffy western suit and
         string tie. Cal Randall, looking as uncomfortable as Jesse felt in his dark suit and cowboy boots. And Cora, in an ankle-skimming
         dress of black silk with a black fringed shawl tossed about her shoulders. It was the first time Jesse could ever recall seeing
         his great-aunt in anything but denim.
      </p>
<p>There were his cousins, tall, handsome, and, like Jesse, refusing to look at the casket standing beside a gaping hole dug
         in the earth.
      </p>
<p>“Who are all these people?”</p>
<p>Wyatt’s muttered question had Jesse studying the crowd. “Townies.”</p>
<p>“So many?” Wyatt exchanged a look with Zane. “When I left, Gold Fever consisted of a gas station, a grocery store, a movie
         theater showing last year’s films, the fairgrounds…”
      </p>
<p>“That held one of the biggest rodeos in the area,” Zane added.</p>
<p>“Yeah. And the Fortune Saloon.”</p>
<p>“Just goes to show how long you’ve been away.” Jesse frowned, realizing just how out-of-touch his cousins were. “In recent
         years they’ve built a high school and a medical clinic. That brought in teachers, doctors, nurses, who in turn needed new
         houses, which brought building contractors. There’s talk that even more land could be developed to accommodate the number
         of people moving…”
      </p>
<p>Jesse’s words died in his throat at the shock of recognition he felt when he spied Otis Parrish in the crowd.</p>
<p>Following his direction, Wyatt hissed out a breath at the sight of their nearest neighbor, in fact, their only neighbor. Knowing
         that Parrish had a long-standing feud with Coot that went back too many years to count, Wyatt whispered, “He’s here for only
         one reason.”
      </p>
<p>“Yeah. To gloat.” Jesse continued studying the crowd.</p>
<p>He felt a nudge in his ribs and glanced over at Wyatt.</p>
<p>“Who’s that?” Wyatt nodded toward a tall, slender woman whose mass of tangled red curls made her a standout in the crowd.</p>
<p>Jesse followed his direction. “Marilee Trainor.”</p>
<p>“Married or single?”</p>
<p>Jesse felt a wave of annoyance. “In case you’ve forgotten, we’re here to bury Coot, not play the dating game.”</p>
<p>“Married or single?”</p>
<p>Jesse sighed. “Single. But don’t bother. She’s a no-nonsense woman who wouldn’t be interested in a quick tumble with a rolling
         stone like you.”
      </p>
<p>“Tell me about her.”</p>
<p>“Lee’s a medic with the town’s emergency services. She was the first one here when she heard about Coot’s fall, and she stayed
         with him until the helicopter arrived.” Jesse felt a twinge of remorse when he saw her lift a handkerchief to her eye. “The
         truth is, she took it personally that she couldn’t save him. From the looks of things, she’s still beating herself up over
         it.”
      </p>
<p>On the other side Zane gave him a nudge and nodded toward the old woman pushing her way to the front of the crowd. “Is that
         Delia Cowling?”
      </p>
<p>“Yeah.”</p>
<p>Zane chuckled. “She was old when I was a kid. Now she must be old as dirt.”</p>
<p>Jesse gave a snort. “Yeah. Our town historian.”</p>
<p>Delia Cowling called herself that because of her collection of dusty books on the subject of the gold rush at Grasshopper
         Creek. Folks in town called her the town gossip. There wasn’t much that happened in the town of Gold Fever that Delia didn’t
         know about.
      </p>
<p>“I’m betting she’s here to gather any information she can about the personal business of anybody in town.”</p>
<p>Ledge Cowling, Delia’s brother and owner of the Gold Fever bank, stood beside his sister, whispering behind his hand. Ledge
         had never married, and most of the folks in town believed it was because the woman hadn’t been born that Ledge could love
         as much as he loved money. Money and his bank were Ledge’s only passions. At least the only ones he’d ever admitted to.
      </p>
<p>Zane and Wyatt continued scanning the faces of so many strangers. There had been a time when they’d known almost everyone
         in the town of Gold Fever. Now, there were few who appeared familiar to them.
      </p>
<p>Zane studied a portly man, his gray hair cut close to his scalp, wearing a uniform. “Is that Ernie Wycliff?”</p>
<p>Jesse nodded. “Yeah. Our old football hero is now the sheriff.”</p>
<p>“Good for Ernie.”</p>
<p>Jesse frowned. “What was Aunt Cora thinking? What did these people care about Coot? Most of ’em are just here to gawk and
         gossip. Tonight they’ll have themselves a good old time back at the Fortune Saloon over a couple of longnecks.”
      </p>
<p>Reverend Carson stepped up beside the casket. His smooth preacher’s voice carried out over the crowd. “I’m told this spot
         has been a burial place for many of the McCord family. Coot’s father and mother are here”—He nodded toward the neat row of
         headstones around which a low, wrought-iron fence stood guard—“along with his baby brother, Edmond, who died in infancy, and
         Coot’s wife, Annie, dead now for over thirty years. Coot’s sister, Cora, told me that her brother considered this holy ground.
         So it seems fitting and proper that old Coot should rest here, now that his labors are over.”
      </p>
<p>He took a paper from his pocket and read the instructions Cora had written, before looking up. “It says here that a couple
         of folks would like to say a few words.” He glanced out over the crowd. “Mayor Stafford?”
      </p>
<p>Jesse couldn’t prevent his eyes from rolling. Rowe Stafford had been the mayor of Gold Fever, Montana, for years, and kept
         getting reelected to office mainly because nobody else cared to run for the job. Though many enjoyed his speeches, Jesse considered
         him a windbag who loved the sound of his own voice.
      </p>
<p>Rowe looked out over the crowd. “Coot and I have been friends for more’n fifty years now. I’ve spent many a night defending
         him to those who called him crazy.” He gave his famous lopsided grin. “But I’ll tell you this. Coot might have gone a little
         overboard when it came to the search for his lost fortune, but he always said he was doing it for his family.” The mayor nodded
         toward Cora and the three handsome young men standing beside her. “It’s good to see the McCords together again, if only for
         a day.” He started to turn away before adding, “I’ll be buying a round of drinks tonight in Coot’s name. It’s the least I
         can do for my oldest friend.”
      </p>
<p>The preacher coughed before saying, “And now we’ll hear a few words from Cal Randall.”</p>
<p>Jesse swiveled his head in surprise and watched as the foreman stepped up beside the casket.</p>
<p>“I just need to say that”—Cal cleared his throat, looking like he’d rather be anywhere than here, baring his soul in front
         of all these friends and neighbors—“these years with Coot have been the best ever. He was fair and honest. His word was his
         bond. He was my best friend. I’m surely going to miss him.” He jammed his hands in his pockets and walked back to join the
         others.
      </p>
<p>Reverend Carson turned to Cora. “Miss McCord?”</p>
<p>Cora stepped away from the others and paused beside the casket, running her hand along the smooth wood. “My brother didn’t
         like fancy words, so I’ll keep mine simple. Folks called him crazy for spending a lifetime searching these hills for our great-grandfather’s
         gold. He never cared what others thought.” She looked over the crowd, allowing her gaze to settle first on Jesse, then Wyatt,
         then Zane. “It just runs in the family, I guess. When your name’s McCord, you have to do things your own way. I surely hope…”
         She gave a long, deep sigh. “I hope his dream doesn’t die with him.”
      </p>
<p>As she took a halting step away, Jesse hurried forward and offered his arm. She gave him a tearful smile, grateful for his
         quiet support.
      </p>
<p>Her voice quavered. “Did you want to say a few words, Jesse?”</p>
<p>He shook his head. “Whatever I’ve got to say to Coot is between him and me. It’s not for here.”</p>
<p>“I understand.” She patted his hand.</p>
<p>The reverend glanced around. “Are there any others who would care to say a few words, or perhaps share a happy memory or two?”</p>
<p>Some of the wranglers shuffled their feet and coughed in discomfort. As the silence stretched out, Reverend Carson opened
         a book and began to read the words of a prayer.
      </p>
<p>As the words drifted over them, Jesse let his attention wander. What would happen to his grandfather’s dream? Since Coot had
         been a young man of eighteen or twenty, he’d been consumed with finding something he wasn’t even sure existed. Nuggets as
         big as a man’s thumb. Some as big as a fist. The old man had been the butt of jokes for as long as Jesse could remember.
      </p>
<p>Maybe it was best if the dream was allowed to die with him. That wasn’t the worst thing that could happen. Maybe then they
         all could have some peace.
      </p>
<p>There was land here. Rich ranchland. And thousands of head of cattle. Old Coot hadn’t cared about the ranch. Had left the
         running of it to Cal and the ranch hands. And Cal did a fine job. No doubt about it. That old cowboy loved this place as if
         it were his own. Still, Jesse thought, maybe if he were to keep his attention focused on the ranch now, without the distraction
         of an imaginary fortune, he and Cal could take the most successful ranch in all of Montana and turn it into the most successful
         ranch in the world.
      </p>
<p>He had the prickly feeling that someone was watching him. Lifting his head he studied the crowd and felt his throat go dry
         when he caught sight of the young woman standing slightly behind Otis Parrish.
      </p>
<p>“Amy.” He wasn’t even aware that he’d spoken her name until he saw his cousins turn to glance at him.</p>
<p>He lowered his head and stared hard at the ground. When Amy Parrish had left Montana without a word, a mile-wide chasm had
         developed between them. And whatever feelings they might have shared had been washed away in a sea of anger and resentment.
      </p>
<p>Jesse was surprised when he sensed movement beside him and realized Cora was starting forward, taking him along with her.
         The casket had already been lowered into the ground, and Cora tossed a handful of dirt onto the lid. Jesse followed suit.
         His cousins, Zane and Wyatt, did the same.
      </p>
<p>They stepped away and watched as Cal and Dandy and the wranglers took turns tossing dirt and standing with bowed heads, bidding
         their final farewells.
      </p>
<p>The crowd had gone eerily silent. Out of respect? Jesse wondered. Or were they waiting for old Coot to rise up out of his
         casket and hold out a fistful of gold nuggets?
      </p>
<p>The minister said in his most funereal tone, “That concludes our service. The family asked me to invite all of you back to
         the house for a meal.”
      </p>
<p>Just then Cora’s voice rose with excitement and she pointed to the sky. “Oh, my. Look.”</p>
<p>Everyone followed her direction, looking up to see a shimmering rainbow arched across the heavens.</p>
<p>A murmur went up from the crowd.</p>
<p>After watching for several minutes, Cora’s voice trembled with excitement. “It’s Coot’s way of saying good-bye. I just know
         it.” She turned to her nephew. “Don’t you agree, Jesse?”
      </p>
<p>He nodded, too overcome to speak. Everyone in the family had seen the rainbow keychain his grandfather had always carried
         in his pocket. When asked about it, old Coot had said it was a symbol of the fortune he intended to find one day. His personal
         pot of gold. It was now Jesse’s good luck charm.
      </p>
<p>“You aren’t just trying to console me, are you?” Cora’s eyes glittered with tears. “You do believe, don’t you, Jess?”</p>
<p>Jesse swallowed the lump in his throat and squeezed her hand. “I’m telling you straight, Aunt Cora. It’s a sign.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MontanaLegacy_chap-2.vue?20cc272a